import Style from "./style.module.css"
import iconDog from "./../../../images/dashboard/mdi_dog.svg";
import iconBanner from "./../../../images/dashboard/banner.svg";
import iconPix from "./../../../images/dashboard/pix.svg";
import iconPeople from "./../../../images/dashboard/people.svg";
import iconUser from "./../../../images/dashboard/user.svg";
import iconSuitor from "./../../../images/dashboard/suitor.svg";
import BaseApi from "src/services/Api";
import React, { useEffect } from "react";
import { toast } from "react-toastify";
import {Spinner} from "react-bootstrap";
import axios from "axios";


export default function Dashboard() {
  const [isLoading, setLoading] = React.useState(true);
  const [countAnimal, setCountAnimal] = React.useState([]);
  const [countBanner, setCountBanner] = React.useState([]);
  const [countDonation, setCountDonation] = React.useState([]);
  const [countSuitor, setCountSuitor] = React.useState([]);
  const [countUser, setCountUser] = React.useState([]);
  const [countPartner, setCountPartner] = React.useState([]);


 let endpoints = [
   "countAnimals",
   "countBanner",
   "countDonation",
   "countSuitor",
   "countUser",
  "countPartner"
 ]

  const requestCount = () => {
      axios.all(endpoints.map((endpoint) => BaseApi.get(endpoint))).then((response) => {
        setCountAnimal(response[0].data);
        setCountBanner(response[1].data);
        setCountDonation(response[2].data);
        setCountSuitor(response[3].data);
        setCountUser(response[4].data);
        setCountPartner(response[5].data);
      }).then((response) => {
        setLoading(false);
      }).catch((err) => {
        if (err) {
          toast.error("Erro ao carregar dados da tabela");
        }
      });
  }


  useEffect(() => {
    requestCount();
  }, [])

  return (
    <>
        <div className="d-flex justify-content-center">
            <p className={Style.welcome}>Seja bem-vindo(a)!</p>
        </div>
    {isLoading && (
      <div className={Style.container}>
        <Spinner animation="border" role="status" className="mx-auto">
            <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    )}
    {!isLoading && (
    <>
    <div className={Style.container}>
      <div className={Style.orientation}>
        <a className={Style.rectangle} href="/admin/animais" alt="botão animais">
          <div className={Style.information}>
            <div className="d-flex justify-content-between align-items-center col">
              <p>ANIMAIS</p>
              <img src={iconDog} alt="animais"/>
            </div>
            <div>{countAnimal}</div>
          </div>
        </a>
        <a className={Style.rectangle} href="/admin/banner" alt="botão banner">
          <div className={Style.information}>
            <div className="d-flex justify-content-between align-items-center col">
              <p>BANNER</p>
              <img src={iconBanner} alt="Banner"/>
            </div>
            <div>{countBanner}</div>
          </div>
        </a>
        <a className={Style.rectangle} href="/admin/doacoes" alt="botão doações">
          <div className={Style.information}>
            <div className="d-flex justify-content-between align-items-center col">
              <p>DOAÇÕES</p>
              <img src={iconPix} alt="Doações"/>
            </div>
            <div>{countDonation}</div>
          </div>
        </a>
      </div>
      <div className={Style.orientation}>
          <a className={Style.lastRectangle} href="/admin/parceiros" alt="botão parceiros">
              <div className={Style.information}>
                  <div className="d-flex justify-content-between align-items-center col">
                      <p>PARCEIROS</p>
                      <img src={iconPeople} alt="Parceiros"/>
                  </div>
                  <div>{countPartner}</div>
              </div>
          </a>
        <a className={Style.lastRectangle} href="/admin/pretendente" alt="botão pretendentes">
          <div className={Style.information}>
            <div className="d-flex justify-content-between align-items-center col">
              <p>PRETENDENTES</p>
              <img src={iconSuitor} alt="Pretendentes"/>
            </div>
            <div>{countSuitor}</div>
          </div>
        </a>
      </div>
        <div className={Style.orientation}>
            <a className={Style.lastRectangle} href="/admin/usuarios" alt="botão usuários">
                <div className={Style.information}>
                    <div className="d-flex justify-content-between align-items-center col">
                        <p>USUÁRIOS</p>
                        <img src={iconUser} alt="Usuários"/>
                    </div>
                    <div>{countUser}</div>
                </div>
            </a>
        </div>
    </div>
    </>
    )}
    </>
  )
}